import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import component from './_import/_component'
import base from './_import/_base'
import matchMedia from './_import/_match-media'
// import pagetop from './_import/_pagetop'
import anchorLink from './_import/_anchor-link';
// import tab from './_import/_tab'
import accordion from './_import/_accordion'
import modal from './_import/_modal'
import globalNav from './_import/_global-nav'
import isScrollbar from './_import/_isScrollbar'
// import popupToggle from './_import/_popup-toggle'
// import filterTab from './_import/_filter-tab'
// import scrollhint from './_import/_scrollhint.js'
// import clearCheckbox from './_import/_clear-checkbox.js'
// import topNewsSlider from './_import/_top-news-slider.js'
import animation from './_import/_animation'
import scrollAnimation from './_import/_animation-fadein'
import animationToppage from './_import/_animation-toppage'
import threeFunctions from './_import/_three-functions'

component.set(base)
component.add('matchMedia', matchMedia)

$(function () {
  gsap.registerPlugin(ScrollTrigger)
})

// pagetop.init()
globalNav.init()
anchorLink.init();
// tab.init()
accordion.init()
modal.init()
isScrollbar.init()
animation.init()
scrollAnimation.init()
animationToppage.init()
threeFunctions.init()
// popupToggle.init()
// filterTab.init()
// scrollhint.init()
// clearCheckbox.init()
// topNewsSlider.init()

// component.add('tab', tab)
component.add('modal', modal)
component.add('accordion', accordion)

const init = () => {
  $('html').removeClass('no-js')
}

init()

$(function () {})
